﻿function setSearchListeners() {
    const searchTab = document.querySelector("[data-search=tab]");
    const searchTabInput = document.querySelector("[data-search=input]");
    const searchTabClose = document.querySelector("[data-search=close]");
    const searchTabIcon = document.querySelector(".js-search-icon");
    const MOBILE_VIEW_CLASS = "mobile-view";
    const SEARCH_OPEN_CLASS = "shoply-search-open";
    const isMobileSearch = () => window.matchMedia("(max-width: 768px)").matches;

    const openSearch = () => {
        if (!searchTab || !searchTabInput) {
            return;
        }

        searchTab.classList.toggle(MOBILE_VIEW_CLASS, isMobileSearch());
        document.body.classList.add(SEARCH_OPEN_CLASS);
        searchTabInput.focus();
        document.dispatchEvent(new CustomEvent("shoply:search-opened"));
    };

    const closeSearch = (clearInput) => {
        if (!searchTab) {
            return;
        }

        searchTab.classList.remove(MOBILE_VIEW_CLASS);
        document.body.classList.remove(SEARCH_OPEN_CLASS);
        document.dispatchEvent(new CustomEvent("shoply:search-closed"));

        if (clearInput && searchTabInput) {
            searchTabInput.value = "";
        }
    };

    if (searchTabIcon && searchTab && searchTabInput) {
        searchTabIcon.addEventListener("click", (event) => {
            event.preventDefault();
            openSearch();
        });
    }

    if (searchTabInput && searchTab) {

        searchTabInput.addEventListener("click", () => {
            openSearch();
        });
    }

    if (searchTabClose && searchTab && searchTabInput) {
        searchTabClose.addEventListener("click", () => {
            closeSearch(true);
        });
    }

    document.addEventListener("click", (event) => {
        const searchResults = document.querySelector(".shoply-autocomplete");
        if (document.body.classList.contains(SEARCH_OPEN_CLASS)
            && searchTab
            && !searchTab.contains(event.target)
            && (!searchResults || !searchResults.contains(event.target))) {
            closeSearch(false);
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape"
            && document.body.classList.contains(SEARCH_OPEN_CLASS)) {
            event.preventDefault();
            closeSearch(false);
            if (searchTabInput) {
                searchTabInput.blur();
            }
        }
    });

}

setSearchListeners();
